import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { ILinkContainerProps } from './LinkContainer.definitions';

/** CSS import */
import Styles from './LinkContainer.module.scss';
import SearchImage from 'images/search-black.png';
import { Link } from 'react-router-dom';
import { useMenuItem } from 'Pages/Blog/Helper/useMenuItem';

const LinkContainer: React.FC<ILinkContainerProps> = ({
  onOpen,
}: ILinkContainerProps) => {
  const menuItem = useMenuItem();

  return (
    <div className={Styles['blog-links-container']}>
      {menuItem.map((item, index) => (
        <Link key={item.id} to={item.link} className={Styles['blog-link']}>
          {item.name}
        </Link>
      ))}
      <Link to="/" className={Styles['blog-link'] + ' ' + Styles['bold']}>
        SHOP
      </Link>
      <KickImage
        src={SearchImage}
        className={Styles['search-icon']}
        onClick={onOpen}
      />
    </div>
  );
};

export default LinkContainer;
